export const TENANT_CHANGE_EVENT = 'tenant-change';

export const triggerTenantChange = () => {
  console.log("[TENANT_EVENT] triggerTenantChange() dispatching event...");
  window.dispatchEvent(new CustomEvent(TENANT_CHANGE_EVENT));
  console.log("[TENANT_EVENT] event dispatched");
};

export const subscribeTenantChange = (callback: () => void) => {
  console.log("[TENANT_EVENT] subscribeTenantChange() registered listener");
  window.addEventListener(TENANT_CHANGE_EVENT, callback);
  return () => {
    console.log("[TENANT_EVENT] subscribeTenantChange() unregistered listener");
    window.removeEventListener(TENANT_CHANGE_EVENT, callback);
  };
};